<div class="calendar-event-list">

	<h3 data-testid="SUBSYS2_DASHBOARD_EVENTS_TITLE_TXT">
		{{ labels().DASHBOARD_EVENTS_COMPONENT_TITLE }} {{ date ? '-' : '' }} {{ date | convertDate:false }}
		<span data-testid="SUBSYS2_DASHBOARD_EVENTS_TITLE_FORMATDATE_TXT" class="date-format" [class.d-none]="!date">
			{{ dateFormat }}
		</span>
	</h3>
	<hr class="title-line" />

	@if (!events.length) {
	<span data-testid="SUBSYS2_DASHBOARD_EVENTS_EMPTY_TXT">
		{{ labels().DASHBOARD_EVENTS_COMPONENT_LIST_EMPTY }}
	</span>
	} @else {
	<div class="event-list-container">

		<div data-testid="SUBSYS2_DASHBOARD_EVENTS_ACCORDION" ngbAccordion #acc="ngbAccordion" [destroyOnHide]="false">
			@for (event of events; track event; let i = $index) {
			<div [ngbAccordionItem]="PANEL_ID_PREFIX+i" [collapsed]="false" class="panel m-0 p-0">

				<div ngbAccordionHeader>
					<div data-testid="SUBSYS2_DASHBOARD_EVENTS_PANEL_HEADER" class="custom-header"
						(click)="acc.toggle(PANEL_ID_PREFIX+i)" (keypress)="acc.toggle(PANEL_ID_PREFIX+i)">
						{{ event.patient }}
						@if(acc.isExpanded(PANEL_ID_PREFIX+i)) {
						<span class="material-icons">expand_less</span>
						}@else {
						<span class="material-icons">expand_more</span>
						}
					</div>
				</div>

				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						<ng-template>
							@for (item of event.items; track $index) {
							<div data-testid="SUBSYS2_DASHBOARD_EVENTS_PANEL_CONTENT" class="custom-item"
								(click)="goToReport(item.caseId, item.dateOfAdjustment)"
								(keypress)="goToReport(item.caseId, item.dateOfAdjustment)">
								<span class="material-icons circle me-3" [class]="eventTypeClass(item)">circle</span>
								<span data-testid="SUBSYS2_DASHBOARD_EVENTS_PANEL_CONTENT_TXT" class="custom-item-text">
									{{ eventItemDesc(item) }}</span>
							</div>
							}
						</ng-template>
					</div>
				</div>

			</div>
			}
		</div>

	</div>
	}
</div>